import styled from "@emotion/styled";

import { NextButton } from "../../share/campaigns/components/share-ui";

export const SecondaryButton = styled(NextButton)`
  height: 3.6rem;
  margin-left: 5rem;
  margin-right: 2rem;
  border: 1px solid var(--primary-color);
  background-color: var(--background-color-primary);
  color: var(--primary-color);

  &:hover {
    border: 1px solid var(--primary-color);
    background-color: var(--background-color-primary);
    color: var(--primary-color);
  }

  &:focus {
    border: 1px solid var(--primary-color);
    background-color: var(--background-color-primary);
    color: var(--primary-color);
  }

  &:disabled {
    background-color: var(--background-color-tertiery);
  }

  &:disabled:hover {
    background-color: var(--background-color-tertiery);
  }
`;
